import {WidgetVerification} from "@/types/frontend";
import localStorage from "local-storage-fallback";
import {api} from "@/frontend/lib/api";

const STORAGE_KEY = "tu_age_verification_result";

export default class TuVerificationStorage {
    public static get(): WidgetVerification | null {
        const storage: string | null = localStorage.getItem(STORAGE_KEY) || null;
        return storage ? (JSON.parse(storage).value as WidgetVerification) : null;
    }


    public static set(data: WidgetVerification) {
        const dt = new Date();
        dt.setDate(dt.getDate() + 30);
        console.log(dt);
        const item = {
            value: data,
            expiry: dt.getTime(),
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(item));
    }

    public static clear(): void {
        localStorage.removeItem(STORAGE_KEY);
    }

    public static async hasExpired() {
        const storage = localStorage.getItem(STORAGE_KEY)
        if (!storage) {
            return true;
        }
        const item = JSON.parse(storage)
        const customer = await api.customerLookup({
            email: item.value.email,
            shop_domain: window.location.host
        });
        return !customer.tagged;
    }
}
